<app-layout>
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('breadcrumb.resetPassword' | translate) }
]"></app-breadcrumb>

  <div id="reset-password">
    <div>
      <app-title title="resetPassword.title" [text]="titleText"></app-title>

      <div class="success-error-message">
        @if (errorKey){
        <div id="general-error" class="error-message">
          <app-icon-warning />&nbsp;
          {{ errorKey | translate }}
        </div>
        }
        @if (success) {
        <div id="success" class="success-message">
          <div class="success-icon">
            <app-icon-envelope />
          </div>
          <div class="success-text">
            <p [innerHTML]="'resetPassword.success.message' | translate: { email: email_value }">
            </p>
            <p class="sub-text">
              {{ 'resetPassword.success.subText' | translate }}
            </p>
          </div>
        </div>
        }
      </div>
      <form id="reset-password-form" class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
        <app-input label="login.email" [formGroup]="form" name="email" type="email" [required]="true" />

        @if (success) {
        <div class="button-group">
          <a routerLink="/" queryParamsHandling="preserve" class="btn btn-primary">{{ 'resetPassword.backToLogin' |
            translate }}</a>
        </div>
        } @else {
        <div class="button-group">
          @if (button_clicked) {
          <app-spinner></app-spinner>
          } @else {
          <button type="submit" class="btn btn-primary" [disabled]="form.invalid">{{
            'resetPassword.submit' | translate
            }}</button>
          }
          <a routerLink="/" queryParamsHandling="preserve" class="btn btn-secondary">{{ 'resetPassword.cancel'
            | translate }}</a>
        </div>
        }
      </form>
    </div>
  </div>
</app-layout>